
import React from "react";
import {
  FilePdfOutlined,
  FileExcelOutlined,
  FileWordOutlined,
  FilePptOutlined,
  FileImageOutlined,
  FileTextOutlined,
  FileMarkdownOutlined,
  FileZipOutlined,
  VideoCameraOutlined,
  AudioOutlined,
  FileOutlined,
} from "@ant-design/icons";
import { getFileConfig } from "@/utils/fileIcons";

interface FileIconProps {
  mimeType: string;
  size?: "small" | "medium" | "large";
  showLabel?: boolean;
}

const iconComponents: Record<string, React.ComponentType<{ style?: React.CSSProperties }>> = {
  FilePdfOutlined,
  FileExcelOutlined,
  FileWordOutlined,
  FilePptOutlined,
  FileImageOutlined,
  FileTextOutlined,
  FileMarkdownOutlined,
  FileZipOutlined,
  VideoCameraOutlined,
  AudioOutlined,
  FileOutlined,
};

const sizeMap = {
  small: { icon: 16, badge: { padding: "2px 6px", fontSize: 9 } },
  medium: { icon: 24, badge: { padding: "4px 8px", fontSize: 10 } },
  large: { icon: 48, badge: { padding: "6px 12px", fontSize: 12 } },
};

export default function FileIcon({
  mimeType,
  size = "medium",
  showLabel = true,
}: FileIconProps) {
  const config = getFileConfig(mimeType);
  const IconComponent = iconComponents[config.icon] || FileOutlined;
  const sizeConfig = sizeMap[size];

  if (!showLabel) {
    return (
      <IconComponent
        style={{
          fontSize: sizeConfig.icon,
          color: config.color,
        }}
      />
    );
  }

  return (
    <div
      className="file-icon-badge"
      style={{
        backgroundColor: config.bg,
        color: config.color,
        padding: sizeConfig.badge.padding,
        fontSize: sizeConfig.badge.fontSize,
        fontWeight: 600,
        borderRadius: 4,
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
      }}
    >
      <IconComponent style={{ fontSize: sizeConfig.icon * 0.75 }} />
      {config.label}
    </div>
  );
}
